import { render, staticRenderFns } from "./OtherImpactingCard.vue?vue&type=template&id=26ccbeb0&scoped=true&"
import script from "./OtherImpactingCard.vue?vue&type=script&lang=js&"
export * from "./OtherImpactingCard.vue?vue&type=script&lang=js&"
import style0 from "./OtherImpactingCard.vue?vue&type=style&index=0&id=26ccbeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ccbeb0",
  null
  
)

export default component.exports